import { type ReactNode } from "react";

import clsx from "clsx";

import { Tooltip } from "@components/tooltip-container";

interface Props {
  name: string;
  isSelected: boolean;
  tooltipComponent?: ReactNode;
  onClick: () => void;
}

export const QuickFilterButton = ({
  name,
  isSelected,
  tooltipComponent,
  onClick,
}: Props) => {
  return (
    <Tooltip
      noInfoCircle
      overlayClassName="bg-v2-secondary"
      content={tooltipComponent}
      showTooltip={!!tooltipComponent}
    >
      <div
        className={clsx(
          "rounded-md h-9 px-3.5 text-sm transition-all flex items-center",
          "text-v2-action font-semibold tracking-wide",
          "border border-transparent hover:border-v2-light cursor-pointer flex-shrink-0",
          "active:shadow-[2px_2px_4px_0px_rgba(0,0,0,0.10)_inset]",
          "active:bg-v2-action-secondary",
          {
            "border border-v2-light bg-v2-action-secondary": isSelected,
          },
        )}
        style={{
          textShadow: "1px 1px 0px var(--v2-bg-primary, #FFF)",
        }}
        onClick={onClick}
      >
        {name}
      </div>
    </Tooltip>
  );
};
